export const isAllIPv4Networks = (networks: string[]): boolean =>
  networks.some((network) => network === '0.0.0.0/0');

export const isAllIPv6Networks = (networks: string[]): boolean =>
  networks.some((network) => network === '::/0');
